var _title, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconFactory = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "a3227331-97f6-4a95-8a4b-ed8988ebea37",
  "data-name": "Layer 1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024"
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Icoontjes_data")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
  points: "668.3 240 668.3 581.9 667.7 581.9 530.8 441.6 530.8 581.9 529.8 581.9 392.9 441.6 392.9 581.5 256.3 441.6 256.3 581.9 256 581.9 256 784 767.3 784 767.3 240 668.3 240"
})));
export default SvgIconFactory;